let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("enTsL")).then(() => parcelRequire('fsB7i'));